import { createTicket } from "../../../services/merpservices";

export const handleCreateTicket = async (createTicketParams, showAlert = false) => {

  try {
    const res = await createTicket(createTicketParams);

    if (res?.data?.status === 200) {
      const ticketId = res?.data?.ticketid;
      const ticketTypeid = res?.data?.ticketTypeid;
     
      if (showAlert) {
        alert(`Ticket Created Successfully!\nTicket ID: ${ticketId}`);
      }

      return { success: true, ticketId, ticketTypeid };
    } else {
      console.error("Ticket creation failed:", res);
      return { success: false, message: "Ticket creation failed", res };
    }
  } catch (error) {
    console.error("Error during ticket creation:", error);
    return { success: false, message: error.message };
  }
};
